import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Row, Col, Spinner } from "react-bootstrap";
import { getDriverDetail } from "../../../../api/driver";
import { Input } from "../../../../components";

const DriverBank = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const [detail, setDetail] = useState({});
    const [loading, setLoading] = useState(true);

    const getData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await getDriverDetail(id);
            setDetail(response);
        } catch (error) {
            console.error("Error fetching driver details:", error);
        } finally {
            setLoading(false);
        }
    }, [id]);

    useEffect(() => {
        getData();
    }, [getData]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">{t("LOADING")}</span>
                </Spinner>
            </div>
        );
    }

    return (
        <Row>
            <Col lg={6} md={6} className="mb-4">
                <Input
                    label={t("BANK_ACCOUNT_NUMBER")}
                    name="bankAccountNumber"
                    formControlProps={{
                        disabled: true,
                        value: detail.bankAccountNumber || ""
                    }}
                />
            </Col>
            <Col lg={6} md={6} className="mb-4">
                <Input
                    label={t("BANK_NAME")}
                    name="bankName"
                    formControlProps={{
                        disabled: true,
                        value: detail.bankName || ""
                    }}
                />
            </Col>
        </Row>
    );
};

export default DriverBank;
